import { Component, ViewChild } from '@angular/core';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { AttendanceDeviceService } from '../../../Model/AttendanceDevice/attendance-device.service';
import { CommonService } from '../../../Model/Common/common.service';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DeviceEssService } from '../../../Model/DeviceEss/device-ess.service';
import { SessionService } from '../../../Util/Session/session.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';

@Component({
  selector: 'app-device',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule, NgSelectModule, LoaderComponent, NgbTooltip],
  templateUrl: './device.component.html',
  styleUrl: './device.component.scss'
})
export class DeviceComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  AllData: any[] = [];
  Data: any[] = [];
  filter = {
    endPoint: "DeviceESS/devicestatus",
    requestBody: {
      CompanyCode: null,
      IsExcel: false,
      BSCode: null
    },
    httpMethod: "Post"
  }
  FilterIndex = 0;
  Card = {
    Online: 0,
    OnlinePer: 0 as any,
    Offline: 0,
    OfflinePer: 0 as any,
  }

  mfilter = {
    BranchMasterID: [] as any,
    ClientGroupMasterID: [] as any,
    SiteMasterID: [] as any,
    SiteOwnerID: [] as any,
  }

  AllSites = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  SiteOwners = [] as any;

  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private modalService: NgbModal,
    private deviceess: DeviceEssService,
    private session: SessionService,
    private employeeRegistration: EmployeeRegistrationService,
  ) {
    this.common.getPageRights();
    this.filter.requestBody.CompanyCode = this.session.GetUserDetails().CompanyCode;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_SiteWiseDeviceDetailsSelect();
    this.ESS_AdditionalFillCombo();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_SiteWiseDeviceDetailsSelect(IsExcel = false) {
    this.isDisabled = true;
    if (!IsExcel) {
      this.Data = [];
      this.AllData = [];
      try {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      } catch (e) { }
    }
    this.filter.requestBody.IsExcel = IsExcel;

    if(this.mfilter.BranchMasterID.length == 0 && this.mfilter.ClientGroupMasterID.length == 0 && this.mfilter.SiteMasterID.length == 0){
      //this.filter.requestBody.BSCode = null;
      this.filter.requestBody.BSCode = this.Sites.map((e:any) => e.SiteMasterID).toString();
    }else{
      if(this.mfilter.SiteMasterID.length > 0){
        this.filter.requestBody.BSCode = this.mfilter.SiteMasterID.toString();
      }else{
        this.filter.requestBody.BSCode = this.Sites.map((e:any) => e.SiteMasterID).toString();
      }
    }

    this.deviceess.commonDeviceApi(this.filter).subscribe({
      next: (response) => {
        try {
          if ((!IsExcel && response && response.length > 0) || (IsExcel && response)) {
            if (IsExcel && response.success) {
              window.open(response.path, '_blank', 'noopener noreferrer');
            } else if (!IsExcel) {
              if (response && response.length > 0) {
                this.Card.Offline = response.filter((e: any) => e.status == 0).length;
                this.Card.Online = response.filter((e: any) => e.status == 1).length;

                this.Card.OfflinePer = ((this.Card.Offline * 100) / (this.Card.Online + this.Card.Offline)).toFixed(2);
                this.Card.OnlinePer = ((this.Card.Online * 100) / (this.Card.Online + this.Card.Offline)).toFixed(2);

                this.AllData = response;
                this.Data = Object.values(response);
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              try {
                this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                  dtInstance.destroy();
                  this.dtTrigger.next(null);
                });
              } catch (e) { }
            }
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterData(index: number) {
    if (this.FilterIndex == index) {
      this.Data = Object.values(this.AllData);
      this.FilterIndex = 0;
    } else {
      this.FilterIndex = index;
      if (index == 1) {
        this.Data = Object.values(this.AllData);
      } else if (index == 2) {
        this.Data = Object.values(this.AllData.filter((e: any) => e.status));
      } else if (index == 3) {
        this.Data = Object.values(this.AllData.filter((e: any) => !e.status));
      }
    }
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    this.Branchs = [];
    this.Clients = [];
    this.Sites = [];
    this.SiteOwners = [];

    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'SW', UserId: this.session.GetUserDetails().UserId
    }).subscribe({
      next: (response) => {
        if (response.Table1) {
          this.AllSites = response.Table1;
          this.Branchs = [...new Map(this.AllSites.map((e: any) => ({ BranchMasterID: e.BranchMasterID, BranchName: e.BranchName })).map((item: any) => [item.BranchMasterID, item])).values()];
          this.Clients = [...new Map(this.AllSites.map((e: any) => ({ ClientGroupMasterID: e.ClientGroupMasterID, ClientGroupName: e.ClientGroupName })).map((item: any) => [item.ClientGroupMasterID, item])).values()];
          this.Sites = [...new Map(this.AllSites.map((e: any) => ({ SiteMasterID: e.SiteCode, SiteName: e.SiteName })).map((item: any) => [item.SiteMasterID, item])).values()];
          this.SiteOwners = [...new Map(this.AllSites.map((e: any) => ({ SiteOwnerID: e.SiteSupervisorId, SiteOwnerName: e.SiteSupervisorName })).map((item: any) => [item.SiteOwnerID, item])).values()];
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  DropdownChange(Key: String) {
    if (Key == 'Branch') {
      this.Clients = [];
      this.mfilter.ClientGroupMasterID = [];
      this.Clients = [...new Map(
        this.AllSites
          .filter((e: any) => {
            const branchMatch = this.mfilter.BranchMasterID.length === 0 ||
              this.mfilter.BranchMasterID.includes(e.BranchMasterID);
            return branchMatch;
          })
          .map((e: any) => ({
            ClientGroupMasterID: e.ClientGroupMasterID,
            ClientGroupName: e.ClientGroupName
          }))
          .map((item: any) => [item.ClientGroupMasterID, item])
      ).values()];
    }

    if (Key == 'Branch' || Key == 'Client') {
      this.Sites = [];
      this.mfilter.SiteMasterID = [];
      this.Sites = [...new Map(this.AllSites
        .filter((e: any) => {
          const branchMatch = this.mfilter.BranchMasterID.length === 0 ||
            this.mfilter.BranchMasterID.includes(e.BranchMasterID);
          const clientMatch = this.mfilter.ClientGroupMasterID.length === 0 ||
            this.mfilter.ClientGroupMasterID.includes(e.ClientGroupMasterID);
          return branchMatch && clientMatch;
        })
        .map((e: any) => ({ SiteMasterID: e.SiteCode, SiteName: e.SiteName })).map((item: any) => [item.SiteMasterID, item])).values()];
    }

    if (Key == 'Branch' || Key == 'Client' || Key == 'Site') {
      this.SiteOwners = [];
      this.mfilter.SiteOwnerID = [];

      this.SiteOwners = [...new Map(this.AllData
        .filter((e: any) => {
          const branchMatch = this.mfilter.BranchMasterID.length === 0 ||
            this.mfilter.BranchMasterID.includes(e.BranchMasterID);
          const clientMatch = this.mfilter.ClientGroupMasterID.length === 0 ||
            this.mfilter.ClientGroupMasterID.includes(e.ClientGroupMasterID);
          const siteMatch = this.mfilter.SiteMasterID.length === 0 ||
            this.mfilter.SiteMasterID.includes(e.SiteMasterID);
          return branchMatch && clientMatch && siteMatch;
        })
        .map((e: any) => ({ SiteOwnerID: e.SiteSupervisorId, SiteOwnerName: e.SiteSupervisorName })).map((item: any) => [item.SiteOwnerID, item])).values()];
    }
  }

  CheckAll(event: any, Type: String) {
    if (Type == 'Branch') {
      if (event.target.checked) {
        this.mfilter.BranchMasterID = this.Branchs.map((e: any) => e.BranchMasterID);
      } else {
        this.mfilter.BranchMasterID = [];
      }
    } else if (Type == 'Client') {
      if (event.target.checked) {
        this.mfilter.ClientGroupMasterID = this.Clients.map((e: any) => e.ClientGroupMasterID);
      } else {
        this.mfilter.ClientGroupMasterID = [];
      }
    } else if (Type == 'Site') {
      if (event.target.checked) {
        this.mfilter.SiteMasterID = this.Sites.map((e: any) => e.SiteMasterID);
      } else {
        this.mfilter.SiteMasterID = [];
      }
    } else if (Type == 'SiteOwner') {
      if (event.target.checked) {
        this.mfilter.SiteOwnerID = this.SiteOwners.map((e: any) => e.SiteOwnerID);
      } else {
        this.mfilter.SiteOwnerID = [];
      }
    }
  }
}
